// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingIntro-pageContent-oXLrR {
	max-width: var(--max-content-width);
	position: relative;
	display: block;
	margin: 0px auto;
	padding: 0px;
}

.ListingIntro-titleText-zgKji {
	font-size: 30px;
	margin: 0px;
	color: var(--primary-foreground);
	font-weight: bold;
	word-break: break-word;
}

.ListingIntro-titleText-zgKji:hover,
.ListingIntro-titleText-zgKji:active,
.ListingIntro-titleText-zgKji:focus {
	color: var(--primary-foreground);
	text-decoration: none;
}

.ListingIntro-sectionTitleText-j6z98 {
	font-size: 20px;
	margin: 0px;
	margin-bottom: 16px;
	font-weight: 600;
}

.ListingIntro-sectionTitleContent-J26Aw {
	font-size: 16px;
	color: var(--secondary-foreground);
}

.ListingIntro-sectionCaptionLink-QvqCT {
	font-size: 16px;
	color: var(--secondary-foreground);
}

a {
	cursor: pointer;
}

a:focus {
	outline: none;
}

.ListingIntro-textMuted-Ur2Sb,
.ListingIntro-textMuted-Ur2Sb:hover,
.ListingIntro-textMuted-Ur2Sb:focus,
.ListingIntro-textMuted-Ur2Sb:hover:focus {
	color: var(--secondary-foreground);
	text-decoration: none;
	font-size: inherit;
}

.ListingIntro-text-tDqu4 {
	color: inherit;
	font-size: inherit;
	font-weight: normal;
}

.ListingIntro-textLine-jFMdD {
	text-decoration: line-through;
}

.ListingIntro-textCenter-tLmLk {
	text-align: center;
}

.ListingIntro-textError-SnHnJ {
	color: var(--alert-color);
}

.ListingIntro-horizontalLineThrough-c8Ffj {
	position: relative;
	display: block;
}

.ListingIntro-pageContent-oXLrR .ListingIntro-horizontalLineThrough-c8Ffj:last-child {
	border-bottom: 0px;
}

.ListingIntro-space1-PrSIJ {
	margin-bottom: 6px;
}

.ListingIntro-space2-_3aUs {
	margin-bottom: 12px;
}

.ListingIntro-space3-sqvzz {
	margin-bottom: 18px;
}

.ListingIntro-space4-DRAiY {
	margin-bottom: 24px;
}

.ListingIntro-space5-mUVcl {
	margin-bottom: 48px;
}

.ListingIntro-spaceTop1-YL4mi {
	margin-top: 6px;
}

.ListingIntro-spaceTop2-xm3Xr {
	margin-top: 12px;
}

.ListingIntro-spaceTop3-E3Qbe {
	margin-top: 18px;
}

.ListingIntro-spaceTop4-JmcEN {
	margin-top: 24px;
}

.ListingIntro-spaceTop5-JqFjj {
	margin-top: 48px;
}

.ListingIntro-padding1-solKe {
	padding-bottom: 6px;
}

.ListingIntro-padding2-kAh7S {
	padding-bottom: 12px;
}

.ListingIntro-padding3-l3Kzz {
	padding-bottom: 18px;
}

.ListingIntro-padding4-y6rgM {
	padding-bottom: 24px;
}

.ListingIntro-padding5-gs7NJ {
	padding-bottom: 48px;
}

.ListingIntro-paddingTop1-sPQHq {
	padding-top: 6px;
}

.ListingIntro-paddingTop2-V9sAl {
	padding-top: 12px;
}

.ListingIntro-paddingTop3-e7oW2 {
	padding-top: 18px;
}

.ListingIntro-paddingTop4-izAiG {
	padding-top: 24px;
}

.ListingIntro-paddingTop5-qiVal {
	padding-top: 48px;
}

.ListingIntro-noMargin-OTyzu {
	margin: 0px;
}

.ListingIntro-noPadding-_tHb_ {
	padding: 0px;
}

.ListingIntro-noBorder-ZxZL2 {
	border: 0px none !important;
}

.ListingIntro-btn-Fyzeo {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: var(--primary-color);
	color: var(--white-color);
	font-weight: bold;
	font-size: 16px;
	outline: none !important;
}

.ListingIntro-btnBlock-mTdYm {
	width: 100%;
	position: relative;
	white-space: normal;
	display: block;
}

.ListingIntro-btn-Fyzeo:hover,
.ListingIntro-btn-Fyzeo:focus,
.ListingIntro-btn-Fyzeo:hover:focus {
	background: transparent;
	color: var(--primary-foreground);
}

.ListingIntro-formControlSelect-r8D9v {
	margin-bottom: 8px;
}

.ListingIntro-splitList-ue9WA {
	display: inline-block;
	width: 50%;
	font-size: 16px;
	padding-right: 8px;
}

.ListingIntro-displayTable-nK4sb {
	display: table;
	width: 100%;
}

.ListingIntro-displayTableRow-qJsZn {
	display: table-row;
	width: 100%;
}

.ListingIntro-displayTableCell-THIIY {
	display: table-cell;
	width: 100%;
}

.ListingIntro-displayTableCellIcon-bY2jO {
	display: table-cell;
	vertical-align: top;
}

.ListingIntro-textMutedNew-HDaSY {
	font-size: 16px;
	font-weight: 700;
	vertical-align: middle;
	word-break: break-word;
	line-height: 26px;
}

.ListingIntro-tableMarginTop-bkvmF {
	margin-top: 16px;
}

.ListingIntro-calendarTableCell-TUOUO {
	display: inline-block;
}

.ListingIntro-vrAlignTop-Vsv7t {
	vertical-align: top;
}

.ListingIntro-currenyMarginR-p3CCn {
	margin-right: 6px;
}

.ListingIntro-sectionLink-yxNk4 {
	border: 1px solid var(--secondary-bg);
	padding: 10px;
	border-radius: 4px;
}

.ListingIntro-listingFontSize-vBrmd {
	font-size: 16px !important;
}

.ListingIntro-vrAlignBottom-3GvgM {
	vertical-align: bottom;
}

.ListingIntro-introTextPadding-_HmIJ {
	padding-left: 8px;
}

.ListingIntro-showHideBtn-FdPaa {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px !important;
	border: 0px !important;
	text-decoration: underline;
}

.ListingIntro-showHideBtn-FdPaa.ListingIntro-focus-FOfRk,
.ListingIntro-showHideBtn-FdPaa:focus,
.ListingIntro-showHideBtn-FdPaa:active,
.ListingIntro-showHideBtn-FdPaa:active:focus,
.ListingIntro-showHideBtn-FdPaa:focus,
.ListingIntro-showHideBtn-FdPaa:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px;
	border: 0px !important;
}

.ListingIntro-showHideMargin-_T7PR {
	margin-bottom: 10px !important;
}

.ListingIntro-listingIntroWidth-T4w0x {
	width: 65%;
}

.ListingIntro-showHidePadding-sXz_T {
	padding-bottom: 10px !important;
}

.ListingIntro-vtrTop-_vr7J {
	vertical-align: top;
}

.ListingIntro-listingLine-wczuz {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ListingIntro-listingLineTwo-gikDT {
	margin: 15px 0 30px;
}

@media screen and (max-width: 767px) {
	.ListingIntro-titleText-zgKji {
		font-weight: 700;
		font-size: 26px;
		word-break: break-word;
	}

	.ListingIntro-splitList-ue9WA {
		display: inline-block;
		width: 100% !important;
	}

	.ListingIntro-listingIntroWidth-T4w0x {
		width: 100% !important;
	}

	.ListingIntro-responsiveListIngIntro-csMvt {
		display: inline-block !important;
	}
}

.ListingIntro-profileAvatarLink-IXfGV {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	border-radius: 50%;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
}

.ListingIntro-profileAvatar-_ahH5 {
	height: 70px;
	width: 70px;
}

.ListingIntro-textMuted-Ur2Sb,
.ListingIntro-textMuted-Ur2Sb:hover,
.ListingIntro-textMuted-Ur2Sb:focus,
.ListingIntro-textMuted-Ur2Sb:hover:focus {
	color: var(--secondary-foreground);
	text-decoration: none;
	font-size: inherit;
}

.ListingIntro-reviewStar-buyKR {
	display: inline;
	position: relative;
	float: left;
}

.ListingIntro-introPadding-VEJA3 {
	padding-bottom: 15px;
}

.ListingIntro-hostNameText-ADJca {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 150px;
	margin: 0 auto;
}

.ListingIntro-personalHomeIcon-y0Pnw {
	position: relative;
	top: 2px;
}

.ListingIntro-flex-Uws5C {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: start;
	    -ms-flex-pack: start;
	        justify-content: flex-start;
}

.ListingIntro-hostNameCss-VPZB7 {
	font-size: 20px;
	padding-left: 25px;
}

.ListingIntro-propertyCss-gwhqO {
	font-size: 16px;
	color: var(--secondary-foreground);
	margin-top: 10px;
}

.ListingIntro-dotCss-uFy1l {
	width: 5px;
	height: 5px;
	background: var(--secondary-foreground);
	border-radius: 50%;
	margin: 0 6px 0 10px;
	display: inline-block;
	position: relative;
	top: -2px;
}

@media screen and (max-width: 640px) {
	.ListingIntro-introCenter-glbI8 {
		text-align: center;
	}

	.ListingIntro-bookItPanel-eZk3h {
		text-align: left;
	}
}

@media screen and (max-width: 767px) {
	.ListingIntro-profileAvatar-_ahH5 {
		height: 54px;
		width: 54px;
	}

	.ListingIntro-profileAvatarNew-a9g5f {
		height: 100px;
		width: 100px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/common.css","webpack://./src/components/ViewListing/ListingIntro/ListingIntro.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;;CAGC,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;;;;CAIC,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,mCAAmC;CACnC,gCAAgC;CAChC,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;;CAGC,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;CACvB,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;;AAEA;;;;;;CAMC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;EACrB,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gCAAgC;CACjC;AACD;;ACjWA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,uCAAuC;AACxC;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;;;;CAIC,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAA2B;KAA3B,oBAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,oBAAoB;CACpB,qBAAqB;CACrB,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,aAAa;EACb,YAAY;CACb;AACD","sourcesContent":[".pageContent {\n\tmax-width: var(--max-content-width);\n\tposition: relative;\n\tdisplay: block;\n\tmargin: 0px auto;\n\tpadding: 0px;\n}\n\n.titleText {\n\tfont-size: 30px;\n\tmargin: 0px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: bold;\n\tword-break: break-word;\n}\n\n.titleText:hover,\n.titleText:active,\n.titleText:focus {\n\tcolor: var(--primary-foreground);\n\ttext-decoration: none;\n}\n\n.sectionTitleText {\n\tfont-size: 20px;\n\tmargin: 0px;\n\tmargin-bottom: 16px;\n\tfont-weight: 600;\n}\n\n.sectionTitleContent {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n.sectionCaptionLink {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\na {\n\tcursor: pointer;\n}\n\na:focus {\n\toutline: none;\n}\n\n.textMuted,\n.textMuted:hover,\n.textMuted:focus,\n.textMuted:hover:focus {\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n\tfont-size: inherit;\n}\n\n.text {\n\tcolor: inherit;\n\tfont-size: inherit;\n\tfont-weight: normal;\n}\n\n.textLine {\n\ttext-decoration: line-through;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.textError {\n\tcolor: var(--alert-color);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.pageContent .horizontalLineThrough:last-child {\n\tborder-bottom: 0px;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.space5 {\n\tmargin-bottom: 48px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.spaceTop5 {\n\tmargin-top: 48px;\n}\n\n.padding1 {\n\tpadding-bottom: 6px;\n}\n\n.padding2 {\n\tpadding-bottom: 12px;\n}\n\n.padding3 {\n\tpadding-bottom: 18px;\n}\n\n.padding4 {\n\tpadding-bottom: 24px;\n}\n\n.padding5 {\n\tpadding-bottom: 48px;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px;\n}\n\n.paddingTop5 {\n\tpadding-top: 48px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: var(--primary-color);\n\tcolor: var(--white-color);\n\tfont-weight: bold;\n\tfont-size: 16px;\n\toutline: none !important;\n}\n\n.btnBlock {\n\twidth: 100%;\n\tposition: relative;\n\twhite-space: normal;\n\tdisplay: block;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:hover:focus {\n\tbackground: transparent;\n\tcolor: var(--primary-foreground);\n}\n\n.formControlSelect {\n\tmargin-bottom: 8px;\n}\n\n.splitList {\n\tdisplay: inline-block;\n\twidth: 50%;\n\tfont-size: 16px;\n\tpadding-right: 8px;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\twidth: 100%;\n}\n\n.displayTableCellIcon {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.textMutedNew {\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tvertical-align: middle;\n\tword-break: break-word;\n\tline-height: 26px;\n}\n\n.tableMarginTop {\n\tmargin-top: 16px;\n}\n\n.calendarTableCell {\n\tdisplay: inline-block;\n}\n\n.vrAlignTop {\n\tvertical-align: top;\n}\n\n.currenyMarginR {\n\tmargin-right: 6px;\n}\n\n.sectionLink {\n\tborder: 1px solid var(--secondary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n}\n\n.listingFontSize {\n\tfont-size: 16px !important;\n}\n\n.vrAlignBottom {\n\tvertical-align: bottom;\n}\n\n.introTextPadding {\n\tpadding-left: 8px;\n}\n\n.showHideBtn {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px !important;\n\tborder: 0px !important;\n\ttext-decoration: underline;\n}\n\n.showHideBtn.focus,\n.showHideBtn:focus,\n.showHideBtn:active,\n.showHideBtn:active:focus,\n.showHideBtn:focus,\n.showHideBtn:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px;\n\tborder: 0px !important;\n}\n\n.showHideMargin {\n\tmargin-bottom: 10px !important;\n}\n\n.listingIntroWidth {\n\twidth: 65%;\n}\n\n.showHidePadding {\n\tpadding-bottom: 10px !important;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.listingLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.listingLineTwo {\n\tmargin: 15px 0 30px;\n}\n\n@media screen and (max-width: 767px) {\n\t.titleText {\n\t\tfont-weight: 700;\n\t\tfont-size: 26px;\n\t\tword-break: break-word;\n\t}\n\n\t.splitList {\n\t\tdisplay: inline-block;\n\t\twidth: 100% !important;\n\t}\n\n\t.listingIntroWidth {\n\t\twidth: 100% !important;\n\t}\n\n\t.responsiveListIngIntro {\n\t\tdisplay: inline-block !important;\n\t}\n}","@import '../common.css';\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n}\n\n.profileAvatar {\n\theight: 70px;\n\twidth: 70px;\n}\n\n.textMuted,\n.textMuted:hover,\n.textMuted:focus,\n.textMuted:hover:focus {\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n\tfont-size: inherit;\n}\n\n.reviewStar {\n\tdisplay: inline;\n\tposition: relative;\n\tfloat: left;\n}\n\n.introPadding {\n\tpadding-bottom: 15px;\n}\n\n.hostNameText {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tmax-width: 150px;\n\tmargin: 0 auto;\n}\n\n.personalHomeIcon {\n\tposition: relative;\n\ttop: 2px;\n}\n\n.flex {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n}\n\n.hostNameCss {\n\tfont-size: 20px;\n\tpadding-left: 25px;\n}\n\n.propertyCss {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tmargin-top: 10px;\n}\n\n.dotCss {\n\twidth: 5px;\n\theight: 5px;\n\tbackground: var(--secondary-foreground);\n\tborder-radius: 50%;\n\tmargin: 0 6px 0 10px;\n\tdisplay: inline-block;\n\tposition: relative;\n\ttop: -2px;\n}\n\n@media screen and (max-width: 640px) {\n\t.introCenter {\n\t\ttext-align: center;\n\t}\n\n\t.bookItPanel {\n\t\ttext-align: left;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.profileAvatar {\n\t\theight: 54px;\n\t\twidth: 54px;\n\t}\n\n\t.profileAvatarNew {\n\t\theight: 100px;\n\t\twidth: 100px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContent": `ListingIntro-pageContent-oXLrR`,
	"titleText": `ListingIntro-titleText-zgKji`,
	"sectionTitleText": `ListingIntro-sectionTitleText-j6z98`,
	"sectionTitleContent": `ListingIntro-sectionTitleContent-J26Aw`,
	"sectionCaptionLink": `ListingIntro-sectionCaptionLink-QvqCT`,
	"textMuted": `ListingIntro-textMuted-Ur2Sb`,
	"text": `ListingIntro-text-tDqu4`,
	"textLine": `ListingIntro-textLine-jFMdD`,
	"textCenter": `ListingIntro-textCenter-tLmLk`,
	"textError": `ListingIntro-textError-SnHnJ`,
	"horizontalLineThrough": `ListingIntro-horizontalLineThrough-c8Ffj`,
	"space1": `ListingIntro-space1-PrSIJ`,
	"space2": `ListingIntro-space2-_3aUs`,
	"space3": `ListingIntro-space3-sqvzz`,
	"space4": `ListingIntro-space4-DRAiY`,
	"space5": `ListingIntro-space5-mUVcl`,
	"spaceTop1": `ListingIntro-spaceTop1-YL4mi`,
	"spaceTop2": `ListingIntro-spaceTop2-xm3Xr`,
	"spaceTop3": `ListingIntro-spaceTop3-E3Qbe`,
	"spaceTop4": `ListingIntro-spaceTop4-JmcEN`,
	"spaceTop5": `ListingIntro-spaceTop5-JqFjj`,
	"padding1": `ListingIntro-padding1-solKe`,
	"padding2": `ListingIntro-padding2-kAh7S`,
	"padding3": `ListingIntro-padding3-l3Kzz`,
	"padding4": `ListingIntro-padding4-y6rgM`,
	"padding5": `ListingIntro-padding5-gs7NJ`,
	"paddingTop1": `ListingIntro-paddingTop1-sPQHq`,
	"paddingTop2": `ListingIntro-paddingTop2-V9sAl`,
	"paddingTop3": `ListingIntro-paddingTop3-e7oW2`,
	"paddingTop4": `ListingIntro-paddingTop4-izAiG`,
	"paddingTop5": `ListingIntro-paddingTop5-qiVal`,
	"noMargin": `ListingIntro-noMargin-OTyzu`,
	"noPadding": `ListingIntro-noPadding-_tHb_`,
	"noBorder": `ListingIntro-noBorder-ZxZL2`,
	"btn": `ListingIntro-btn-Fyzeo`,
	"btnBlock": `ListingIntro-btnBlock-mTdYm`,
	"formControlSelect": `ListingIntro-formControlSelect-r8D9v`,
	"splitList": `ListingIntro-splitList-ue9WA`,
	"displayTable": `ListingIntro-displayTable-nK4sb`,
	"displayTableRow": `ListingIntro-displayTableRow-qJsZn`,
	"displayTableCell": `ListingIntro-displayTableCell-THIIY`,
	"displayTableCellIcon": `ListingIntro-displayTableCellIcon-bY2jO`,
	"textMutedNew": `ListingIntro-textMutedNew-HDaSY`,
	"tableMarginTop": `ListingIntro-tableMarginTop-bkvmF`,
	"calendarTableCell": `ListingIntro-calendarTableCell-TUOUO`,
	"vrAlignTop": `ListingIntro-vrAlignTop-Vsv7t`,
	"currenyMarginR": `ListingIntro-currenyMarginR-p3CCn`,
	"sectionLink": `ListingIntro-sectionLink-yxNk4`,
	"listingFontSize": `ListingIntro-listingFontSize-vBrmd`,
	"vrAlignBottom": `ListingIntro-vrAlignBottom-3GvgM`,
	"introTextPadding": `ListingIntro-introTextPadding-_HmIJ`,
	"showHideBtn": `ListingIntro-showHideBtn-FdPaa`,
	"focus": `ListingIntro-focus-FOfRk`,
	"showHideMargin": `ListingIntro-showHideMargin-_T7PR`,
	"listingIntroWidth": `ListingIntro-listingIntroWidth-T4w0x`,
	"showHidePadding": `ListingIntro-showHidePadding-sXz_T`,
	"vtrTop": `ListingIntro-vtrTop-_vr7J`,
	"listingLine": `ListingIntro-listingLine-wczuz`,
	"listingLineTwo": `ListingIntro-listingLineTwo-gikDT`,
	"responsiveListIngIntro": `ListingIntro-responsiveListIngIntro-csMvt`,
	"profileAvatarLink": `ListingIntro-profileAvatarLink-IXfGV`,
	"profileAvatar": `ListingIntro-profileAvatar-_ahH5`,
	"reviewStar": `ListingIntro-reviewStar-buyKR`,
	"introPadding": `ListingIntro-introPadding-VEJA3`,
	"hostNameText": `ListingIntro-hostNameText-ADJca`,
	"personalHomeIcon": `ListingIntro-personalHomeIcon-y0Pnw`,
	"flex": `ListingIntro-flex-Uws5C`,
	"hostNameCss": `ListingIntro-hostNameCss-VPZB7`,
	"propertyCss": `ListingIntro-propertyCss-gwhqO`,
	"dotCss": `ListingIntro-dotCss-uFy1l`,
	"introCenter": `ListingIntro-introCenter-glbI8`,
	"bookItPanel": `ListingIntro-bookItPanel-eZk3h`,
	"profileAvatarNew": `ListingIntro-profileAvatarNew-a9g5f`
};
module.exports = ___CSS_LOADER_EXPORT___;
